import * as v from "valibot";
import { ContactMessageStatus, FeedbackType, ReportReason } from "../../feedback";
import { pageRequest, pageResponse } from "../paging.dto";

const statusDto = v.picklist(Object.values(ContactMessageStatus));

export const adminContactMessageDto = v.object({
  id: v.string(),
  name: v.string(),
  email: v.string(),
  subject: v.string(),
  message: v.string(),
  status: statusDto,
  createdAt: v.number(),
  updatedAt: v.number(),
});
export type AdminContactMessage = v.InferOutput<typeof adminContactMessageDto>;

export const adminArticleRefDto = {
  userId: v.string(),
  authorAlias: v.string(),
  articleId: v.string(),
  /** Empty when the article row is gone. */
  title: v.string(),
  createdAt: v.number(),
};

export const adminReportDto = v.object({
  ...adminArticleRefDto,
  reason: v.picklist(Object.values(ReportReason)),
  explanation: v.nullable(v.string()),
});
export type AdminReport = v.InferOutput<typeof adminReportDto>;

export const adminFeedbackDto = v.object({
  ...adminArticleRefDto,
  feedbackType: v.picklist(Object.values(FeedbackType)),
});
export type AdminFeedback = v.InferOutput<typeof adminFeedbackDto>;

export const listAdminMessagesRequest = { status: v.optional(statusDto), ...pageRequest };
export const listAdminMessagesResponse = { messages: v.array(adminContactMessageDto), ...pageResponse };

export const adminMessageIdRequest = { id: v.pipe(v.string(), v.minLength(1), v.maxLength(64)) };
export const putAdminMessageRequest = { ...adminMessageIdRequest, status: statusDto };
export const adminMessageResponse = { message: adminContactMessageDto };

export const listAdminReportsRequest = pageRequest;
export const listAdminReportsResponse = { reports: v.array(adminReportDto), ...pageResponse };

export const listAdminFeedbacksRequest = pageRequest;
export const listAdminFeedbacksResponse = { feedbacks: v.array(adminFeedbackDto), ...pageResponse };
